import { useEffect } from 'react';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos'; // Import AOS library

export const TitleQuote = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            offset: 100, // Trigger offset
            easing: 'ease-in-out', // Animation easing
            once: false, // Only animate once when in view
        });
    }, []);

    return (
        <>
            <div className="container mt-4">
                <div className="card mb-4" data-aos="fade-up">
                    <div className="card-header" style={{ backgroundColor: '#fe7373', color: 'white' }}>
                        Quote
                    </div>
                    <div className="card-body">
                        <blockquote className="blockquote mb-0" style={{ color: 'red' }}>
                            <h4>No one appreciates the 'BEST' in you, but everyone fears the 'Beast' in you</h4>
                            <br />
                            <footer className="blockquote-footer">
                                From the pain of a wolf <cite title="Source Title"></cite>
                            </footer>
                        </blockquote>
                    </div>
                </div>
            </div>
        </>
    );
};
